import moment from "moment";
import TimerFormat from "./TimerFormat";
import { makeMeTwoDigits } from "./MakeMeTwoDigits";

const dayHourMinute = (live: any) => {
  const then = moment(live);
  const now = moment();
  const timeBetween = moment.duration(then.diff(now));

  // Assuming makeMeTwoDigits ensures two-digit formatting
  const days = makeMeTwoDigits(timeBetween.days()).split('');
  const hours = makeMeTwoDigits(timeBetween.hours()).split('');
  const mins = makeMeTwoDigits(timeBetween.minutes()).split('');
  const secs = makeMeTwoDigits(timeBetween.seconds()).split('');

  // Return logic based on whether the duration has any significant component
  if (timeBetween.days() <= 0) {
    // Assuming TimerFormat can conditionally handle missing days or format flag
    return <TimerFormat hours={hours} mins={mins} secs={secs} format={true} />;
  } else {
    return (
      <TimerFormat days={days} hours={hours} mins={mins} />
      // Or for simple text return:
      // return `${days}D ${hours}H ${mins}M`;
    );
  }
};

export default dayHourMinute;
